import React from 'react';
import { Download, GitCompare, History, ShieldAlert } from 'lucide-react';
interface HeaderProps {
  onStampSnapshot: () => void;
  onViewHistorical: () => void;
  onCompare: () => void;
  onExport: () => void;
}
export function Header({
  onStampSnapshot,
  onViewHistorical,
  onCompare,
  onExport
}: HeaderProps) {
  return <header className="flex flex-col md:flex-row md:items-center justify-between gap-4 mb-8" data-id="element-165">
      <div data-id="element-166">
        <h1 className="text-3xl font-bold text-white tracking-tight mb-2" data-id="element-167">
          AVP Closing Performance
        </h1>
        <div className="flex items-center gap-3 text-sm" data-id="element-168">
          <span className="text-slate-400 font-medium" data-id="element-169">
            April 2026 Performance
          </span>
          <div className="flex items-center gap-2 px-2.5 py-1 rounded-full bg-indigo-500/10 border border-indigo-500/20 text-indigo-300" data-id="element-170">
            <span className="relative flex h-2 w-2" data-id="element-171">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-indigo-400 opacity-75" data-id="element-172"></span>
              <span className="relative inline-flex rounded-full h-2 w-2 bg-indigo-500" data-id="element-173"></span>
            </span>
            In Progress
          </div>
          <span className="text-slate-500" data-id="element-174">Last refreshed: Just now</span>
        </div>
      </div>

      <div className="flex flex-wrap items-center gap-3" data-id="element-175">
        <button onClick={onViewHistorical} className="flex items-center gap-2 px-4 py-2 rounded-lg glass-panel hover:bg-white/10 text-slate-300 text-sm font-medium transition-colors" data-id="element-176">
          <History className="w-4 h-4" data-id="element-177" />
          Historical
        </button>
        <button onClick={onCompare} className="flex items-center gap-2 px-4 py-2 rounded-lg glass-panel hover:bg-white/10 text-slate-300 text-sm font-medium transition-colors" data-id="element-178">
          <GitCompare className="w-4 h-4" data-id="element-179" />
          Compare
        </button>
        <button onClick={onExport} className="flex items-center gap-2 px-4 py-2 rounded-lg glass-panel hover:bg-white/10 text-slate-300 text-sm font-medium transition-colors" data-id="element-180">
          <Download className="w-4 h-4" data-id="element-181" />
          Export
        </button>
        <button onClick={onStampSnapshot} className="flex items-center gap-2 px-5 py-2.5 rounded-lg bg-gradient-to-r from-indigo-600 to-violet-600 hover:from-indigo-500 hover:to-violet-500 text-white text-sm font-semibold shadow-[0_0_20px_rgba(79,70,229,0.3)] hover:shadow-[0_0_25px_rgba(79,70,229,0.5)] transition-all border border-indigo-400/30" data-id="element-182">
          <ShieldAlert className="w-4 h-4" data-id="element-183" />
          Stamp Monthly Snapshot
        </button>
      </div>
    </header>;
}